<template>
	<div class="role">
		<el-button @click="showDialog2('add')" class="add qjc-fts-16">添加企業</el-button>
		<el-table
			:data="list"
			style="width: 100%"
		>
			<template slot="empty">
				<div class="empty-wrap">
					<el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
					<div class="empty-text">暫無數據</div>
				</div>
			</template>
			<el-table-column
				label="編號"
				prop="id" min-width="60"
			></el-table-column>
			<el-table-column
				label="企業名稱"
				prop="name"
			>
				
			</el-table-column>
			<el-table-column
				label="狀態"
				prop="status"
			>
				<template slot-scope="scope">
					<span class="order_status_80" v-if="scope.row.status == 1 ">啓用</span>
					
					<span class="pay_status_1" v-else>停用</span>
				</template>
			</el-table-column>
			<el-table-column
				label="操作日期"
				prop="updated_at" 					min-width="180"
			>
				<template slot-scope="scope">
					<div class="">{{scope.row.updated_at ? scope.row.updated_at : '--'}}</div>
				</template>
			</el-table-column>
			
			<el-table-column
				label="操作"
			>
				<template slot-scope="scope">
					<div class="btn-text" @click="showDialog2('edit',scope.row.id)" >修改</div>
				</template>
			</el-table-column>
			
		</el-table>
		<!-- <el-row :gutter="20" v-show="downFile">
		    <el-col :span="12">
		        <button type="submit" class="download-excel nextBtn2" @click="isAlert3 = true">下載成excel文件</button>
		        <form :action="http" method="post" autocomplete="off"
		              v-show="false">
		            <input type="text" name="sn1" :value="formData3.sn1">
		            <input type="text" name="sn2" :value="formData3.sn2">
		            <input type="text" name="act" :value="formData3.act">
		            <button type="submit" ref="down">下載成excel文件</button>
		        </form>
		    </el-col>
		</el-row> -->
		
		
		<!-- 分頁 -->
		<el-pagination
			@current-change="pageChange"
			:current-page.sync="pager.page"
			hide-on-single-page
				prev-text="上一頁"
				next-text="下一頁"
			:page-size="pager.pagesize"
			layout="total, prev, pager, next,jumper" 
			:total="pager.count">
		</el-pagination>
		
		<el-dialog
		  :title="(oper2 == 'add'?'添加':(oper2 == 'edit'?'修改':'')) + '企業'"
		  :visible.sync="isAlert2"
		  width="50%" :close-on-click-modal="false">
			<el-form
				:model="formData2"
				:rules="rules2"
				ref="form2"
			>
				<el-form-item
					label="企業名稱"
					prop="name"
				>
					<div class="code_cell">
						<el-input
							v-model.trim="formData2.name"
							placeholder="請輸入"
							:maxlength="20"
						></el-input>
					</div>
				</el-form-item>
				<el-form-item
					label="排序"
					prop="sort"
				>
					<el-input
						v-model="formData2.sort"
						placeholder="請輸入"
					></el-input>
				</el-form-item>
				<el-form-item
					label="是否啓用"
					prop="status"
				>
					<el-switch
					  v-model="formData2.status"
					  active-color="#38E019"
					  inactive-color="#FF5219">
					</el-switch>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button class="cancel-btn" @click="formCancel2">取消</el-button>
				<el-button class="submit-btn" @click="formSubmit2">提交</el-button>
			</span>
		</el-dialog>
			
	</div>
</template>

<script>
	import { adminCompany } from '@/js/axios.js';
	import { dateStrChangeTimeTamp } from '@/utils';
	
	export default {
		name: 'companyList',
		data() {
			return {
				submiting: false, // 正在請求
				list: [], //列表
				usedList: [],
				id: '',
				pager: {
					count: 0, // 總條數
					page: 1, // 當前頁
					pagecount: 0, // 總頁數
					pagesize: 10 // 每頁條數
				},
				isAlert: false,
				oper: '',
				oper2: '',
				formData2: {
					name: '',
					sort: 100,
					status: true
				},
				disc: '',
				downAct: 'coupon',
				isAlert2: false,
				remarkId: '',
				newRemark: '',
				isUsedShow: false,
				typeOptions: [{	
						value: '1',
						label: '男',
					},{
						value: '2',
						label: '女',
					}
				],
				packageOptions: [],
				rules2: {
					name: [
						{ required: true, message: '請輸入企業名稱', trigger: 'blur' }
					],
					sort: [
						{ required: false, message: '請輸入排序', trigger: 'blur' }
					],
					status: [
						{ required: false, message: '請選擇啓用狀態', trigger: 'blur' }
					],
				},
				
				
			};
		},
	
		mounted() {
			this.getList();
		},
		components: {},
		watch: {
			
		},
		methods: {
			handlePackage(e) {
				
			},
			handleStatus(val) {
				let status = val.status == 2 ? 0 : val.status;
				adminCompany({act: 'update', id: val.id, status: status, sort: val.sort, name: val.name }).then((res) => {
					if(res.code == 200) {
						this.getList();
					} else {
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				})
			},
			// 獲取列表
			getList() {
				adminCompany({
					page: this.pager.page, // 當前頁
					pagesize: this.pager.pagesize // 每頁條
				}).then(res => {
					if(res.code == 200){
						let list = JSON.parse(window.atob(res.data));
						this.list = list.data;
						this.pager = list.pager;
						
						// 數值可能為字符串，需轉換為number
						for(var key in this.pager){
							this.pager[key] = parseInt(this.pager[key]);
						}
						
					}else{
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				});
			},
			
			pageChange(page) {
				this.pager.page = page;
				this.getList();
			},
			showDialog2 (oper, id) {
				this.oper2 = oper;
				this.isAlert2 = true;
				if(id) {
					this.id = id;
					this.handleLoadDetail(id)
				}
				// this.handleGoodsList();
			},
			handleLoadDetail (id) {
				adminCompany({
					act: 'detail',
					id: id
				}).then(res => {
					if(res.code == 200){
						let result = JSON.parse(window.atob(res.data));
						result.status = result.status == 1
						this.formData2 = result
					}else{
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				});
			},
			
			formSubmit2() {
				if(this.formData2.name.trim() == '') {
					this.$myAlert({
						type: 'fail',
						title: '請輸入部門名稱'
					});
					return
				}
				this.$refs.form2.validate(isSuc => {
					if(isSuc){
						let data = {...this.formData2};
						data.status = data.status ? '1' : '0';
						if(this.oper2 == 'add') {
							data.act = 'add';
						} else if(this.oper2 == 'edit'){
							data.act = 'update';
							data.id = this.id
						}
						
						adminCompany(data).then((res) => {
							if(res.code == 200) {
								this.isAlert2 = false;
								this.noTimes = false;
								this.formData2.name = '';
								this.$refs.form2.resetFields();
								this.$myAlert({
									type: 'success',
									title: res.msg
								});
								this.getList();
							} else {
								this.$myAlert({
									type: 'fail',
									title: res.msg
								});
							}
						})
						
						
					}
				
				})
			},
			formCancel2() {
				this.formData2.name = '';
				this.$refs.form2.resetFields();
				this.noTimes = false;
				this.isAlert = false;
				this.isAlert2 = false;
			},
			handleDel(id) {
				this.$myAlert({
					title: '確定刪除？',
					callback: () => {// 點擊確認觸發
						// getCoupon({act: 'del', id: id}).then((res) => {
						// 	if(res.code == 200) {
								
						// 		this.isAlert = false;
						// 		this.noTimes = false;
						// 		this.$refs.form.resetFields();
						// 	} else {
						// 		this.$myAlert({
						// 			type: 'fail',
						// 			title: res.msg
						// 		});
						// 	}
						// })
					}
				});
			},
		}
	};
</script>

<style scoped>
	.el-dialog .el-form .el-form-item >>>  .code_cell .el-input__inner {
		padding-right: 80px !important;
	}
	.el-dialog .el-form .el-form-item >>> .el-date-editor.el-input, .el-dialog .el-form .el-form-item >>> .el-date-editor.el-input__inner {
		width: 100%;
	}
	.el-dialog .el-form .el-form-item >>> .el-select {
		width: 100%;
	}
	.el-dialog .el-form >>> .el-form-item {
		margin-bottom: 8px;
	}
	.el-dialog .el-form >>> .el-form-item__label{
		width: 16%;
		padding-right: 24px;
		margin-left: 4%;
		text-align: right;
	}
	.el-dialog .el-form >>> .el-form-item__content{
		float: left;
		width: 60%;
		margin-right: 0;
	}
	.right-wrap >>> .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #6681FA;
	}
	.right-wrap >>> .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #6681FA;
		border-color: #6681FA;
	}
	.right-wrap >>> .el-switch__core:after {
		background-color: #828DBC;
	}
	.right-wrap >>> .el-switch.is-checked .el-switch__core::after {
		background-color: #6681FA;	
	}
	.right-wrap >>> .el-input-number__increase {
		display: none;
	}
	.right-wrap >>> .el-input-number__decrease {
		display: none;
	}
	.right-wrap .input-number >>> .el-input__inner {
		height: 30px;
		border: none;
		border-bottom: 1px solid #CED4F0;
		border-radius: 0;
		padding: 0;
		margin-left: 10px;
	}
	.used_dialog >>> .el-dialog__body {
		padding: 0 20px 30px;
	}
	::v-deep input::-webkit-outer-spin-button,::v-deep input::-webkit-inner-spin-button{
	  -webkit-appearance: none !important;
	}
	::v-deep input[type='number']{
	  line-height: 1;
	  -moz-appearance: textfield !important;
	}
	
	.role >>> thead th{
		background: #FAFBFC;
		color: #40444D;
		font-size: 14px;
		font-weight: 500;
	}
</style>
<style lang="scss" scoped>
	.role{
		// display: flex;
		width: 100%;
		height: 100%;
		padding: 20px;
		padding-top: 4px;
		background-color: #fff;
		
		.left-menus {
			min-width: 170px;
			width: 170px;
			padding: 30px 24px;
			border-right: 1px solid #E5E8F5;
			background-color: #ffffff;
			
			.add-action {
				display: flex;
				align-items: center;
				cursor: pointer;
				
				.add-action-img {
					display: flex;
					align-items: center;
					align-items: center;
					width: 24px;
					height: 24px;
					background-color: #6883FB;
					border-radius: 50%;
					
					&::after {
						content: "+";
						width: 100%;
						font-size: 20px;
						color: #fff;
						text-align: center;
						margin-bottom: 4px;
					}
				}
				.add-action-text {
					font-size: 14px;
					color: #6883FB;
					margin-left: 8px;
				}
			}
			.left-list {
				padding-top: 20px;
			}
			
			.left-enp-item {
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #525866;
				line-height: 20px;
				cursor: pointer;
			}
			.left-enp-item-active {
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				line-height: 20px;
			}
		}
		
		.right-wrap {
			flex: 1;
			padding: 36px 24px;
			overflow: auto;
			
			.right-temp {
				margin-bottom: 32px;
				
				.temp-title {
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 18px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #293033;
					line-height: 24px;
					padding-bottom: 10px;
					border-bottom: 1px solid #E5E8F5;
				}
				
				.temp-info {
					margin-top: 12px;
				}
			}
			
			.submit-btn {
				width: 94px;
				height: 34px;
				font-size: 15px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				line-height: 34px;
				background-color: #6883FB;
				border-radius: 17px;
				border: none;
				margin-top: 10px;
			}
			.info-cell {
				margin-bottom: 20px;
			}
			.input-number {
				width: 50px;
			}
			.custom-info {
				position: relative;
				width: 670px;
				padding: 24px;
				border: 1px solid #CED4F0;
				border-radius: 4px;
				margin-top: 10px;
				
				&::before {
					box-sizing: content-box;
					position: absolute;
					width: 0;
					height: 0;
					top: -16px;
					left: 41px;
					padding: 0;
					border-top: 8px solid transparent;
					border-left: 8px solid transparent;
					border-right: 8px solid transparent;
					border-bottom: 8px solid #fff;
					display: block;
					content: '';
					z-index: 12;
				}
				
				&::after {
					box-sizing: content-box;
					position: absolute;
					width: 0;
					height: 0;
					top: -18px;
					left: 40px;
					padding: 0;
					border-top: 9px solid transparent;
					border-left: 9px solid transparent;
					border-right: 9px solid transparent;
					border-bottom: 9px solid #CED4F0;
					display: block;
					content: '';
					z-index: 10;
				}
			}
			.custom-group {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				
				.custom-item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 30%;
					margin-right: 20px;
				}
			}
		}
		
		.add{
			padding: 8px 12px;
			margin: 12px 0;
			color: #fff;
			border: none;
		}
		
		.el-table{
			i[class^=el-icon]{
				margin-right: 16px;
				cursor: pointer;
			}
		}
		
		.el-pagination{
			text-align: center;
			margin-top: 32px;
		}
		
		.el-dialog{
			
			.dialog-title {
				font-size: 18px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #293033;
				text-align: center;
			}
			.all-power{
				-webkit-appearance: none;
				background-color: #FFF;
				background-image: none;
				border-radius: 4px;
				border: 1px solid #DCDFE6;
				box-sizing: border-box;
				color: #606266;
				display: inline-block;
				font-size: inherit;
				height: 40px;
				line-height: 40px;
				outline: 0;
				padding: 0 15px;
				transition: border-color .2s cubic-bezier(.645,.045,.355,1);
				width: 100%;
			}
			.dialog-footer{
				display: flex;
				align-items: center;
				justify-content: center;
				.cancel-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #6883FB;
					border: 1px solid #6883FB;
					border-radius: 17px;
					background-color: #fff;
				}
				.submit-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #fff;
					border: none;
					border-radius: 17px;
					background-color: #6883FB;
					margin-left: 16px;
				}
				.el-button{
					padding: 9px 15px;
				}
			}
		}
	}
	
	.quota_cell {
		position: relative;
		display: flex;
		align-items: center;
		
		.unit {
			position: absolute;
			right: 10px;
			top: 0px;
		}
	}
	.times_cell {
		display: flex;
		align-items: center;
		
		.noTimes {
			height: 40px;
			padding: 0 12px;
			margin-left: 10px;
			border: 1px solid #DCDFE6;
			border-radius: 4px;
		}
		.active {
			border: 1px solid #6681FA;
		}
	}
	.empty-wrap {
		padding: 100px 0;
	}
	.empty-img {
		width: 338px;
		height: 218px;
	}
	.code_cell {
		position: relative;
		display: flex;
		align-items: center;
		
		input {
			padding-right: 80px;
		}
		
		.code_btn {
			position: absolute;
			top: 0;
			right: 20px;
			font-size: 14px;
			font-family: PingFang SC-Light, PingFang SC;
			font-weight: 300;
			color: #6883FB;
			cursor: pointer;
			z-index: 99;
		}
	}
	
	.el-icon-edit {
		color: #6681FA;
	}
	
	.user_btn {
		color: #6681FA;
		cursor: pointer;
	}
	
	.el-pagination{
		text-align: center;
		margin-top: 32px;
	}
	
	.tips_p {
		font-size: 14px;
		padding: 0 78px;
		margin-bottom: 10px;
		text-align: left;
		
	}
	.btn-text {
		color: #6883FB;
	}
</style>
